"use client";

import { usePathname } from "next/navigation";
import { useSendbirdContext } from "@/sendbird/useSendbirdContext";
import useListOfPromocodes from "hooks/swr/useListOfPromocodes";
import { selectIsUserLoggedIn } from "stores/auth/authSlice";
import { useAppSelector } from "stores/hooks";
import AppDesktopHeaderMenu from "../header/AppDesktopHeaderMenu";
import { LogInToPortalButton } from "../header/LogInToPortalButton";
import { WelcomeUserText } from "../header/WelcomeUserText";
export const HeaderMenuPill = () => {
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  const {
    unreadCount
  } = useSendbirdContext();
  const {
    data: promoCodesList
  } = useListOfPromocodes();
  const pathname = usePathname();
  const isPaymentPage = pathname?.startsWith("/payment");
  return <div className='flex items-center gap-2 text-white' data-sentry-component="HeaderMenuPill" data-sentry-source-file="HeaderMenuPill.tsx">
      <LogInToPortalButton className='text-white' data-sentry-element="LogInToPortalButton" data-sentry-source-file="HeaderMenuPill.tsx" />
      <WelcomeUserText className='!hidden text-white lg4:!flex' data-sentry-element="WelcomeUserText" data-sentry-source-file="HeaderMenuPill.tsx" />
      {(isLoggedIn || !isLoggedIn && !isPaymentPage) && <AppDesktopHeaderMenu unreadCount={unreadCount} promoCodesList={promoCodesList} />}
    </div>;
};